import {getDefaultPageForRole} from "~/utils/roles";

export default defineNuxtRouteMiddleware((to, from) => {
    const {currentRoutePath, user} = useAuth()
    currentRoutePath.value = to.path
})
